import * as React from 'react';

import { useVirtual } from 'react-virtual';

import { PaywallDispatch } from '~teacher/components/PaywallDialog';
import { QuizListFolder } from '~teacher/components/quizzes/QuizListItem/QuizListFolder';
import { QuizListQuiz } from '~teacher/components/quizzes/QuizListItem/QuizListQuiz';
import { ShareDialogDispatch } from '~teacher/components/ShareQuizDialog/types';

import { QuizOrFolder } from '../../../api/quiz/getQuizzes/types';

export type Props = {
  items: QuizOrFolder[];
  selectedQuizItem: Set<string>;
  toggleItem: (itemToToggle: string) => void;
  closeSearchField?: () => void;
  disableHover?: boolean;
  paywallDispatch?: PaywallDispatch;
  shareDialogDispatch?: ShareDialogDispatch;
};

export const VirtualQuizFolderList = ({
  items,
  selectedQuizItem,
  toggleItem,
  disableHover,
  paywallDispatch = () => {
    /* empty */
  },
  shareDialogDispatch,
}: Props) => {
  const parentRef = React.useRef<HTMLDivElement>();

  const windowRef = React.useRef(window);
  const estimateSize = React.useCallback(() => 54, []);
  const rowVirtualizer = useVirtual({
    size: items.length,
    overscan: 5,
    parentRef,
    windowRef: windowRef,
    estimateSize: estimateSize,
  });

  return (
    <>
      <div
        ref={parentRef}
        className="List"
        style={{
          width: `100%`,
        }}
      >
        <div
          style={{
            height: `${rowVirtualizer.totalSize}px`,
            width: '100%',
            position: 'relative',
          }}
        >
          {rowVirtualizer.virtualItems.map((virtualRow) => {
            const item = items[virtualRow.index];
            return (
              <div
                key={virtualRow.index}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: `${virtualRow.size}px`,
                  transform: `translateY(${virtualRow.start}px)`,
                }}
              >
                {item.type === 'folder' ? (
                  <QuizListFolder
                    {...item}
                    key={item.uniqueId}
                    isChecked={selectedQuizItem.has(item.uniqueId)}
                    toggleItem={toggleItem}
                    disableHover={disableHover}
                  />
                ) : (
                  <QuizListQuiz
                    {...item}
                    key={item.uniqueId}
                    toggleItem={toggleItem}
                    isChecked={selectedQuizItem.has(item.uniqueId)}
                    disableHover={disableHover}
                    shareDialogDispatch={shareDialogDispatch}
                    paywallDispatch={paywallDispatch}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
